<template>
    <header id="idea_header">
        <div class="left">
            <a href="https://www.modian.com/" target="_blank">
                <img src="https://s.moimg.net/dist/img/modian-logo.png" title="摩点 - 文化创意众筹社区">
            </a>
            <p>{{title}}</p>
        </div>
        <div class="right">
            <div class="btn_list">
                <template v-if="$route.name != 'idea_update' && stepIndex == 0 && ideaStatus < 30 && !$route.name.includes('initiate_')">
                    <el-button type="primary" @click.stop="confirm">下一步</el-button>
                </template>
                <template v-else>
                    <el-button v-if="$route.name == 'idea'" type="primary" @click.stop="confirm">提交审核</el-button>
                    <el-button v-if="$route.name == 'idea_update'" type="primary" @click.stop="confirm">发布更新</el-button>
                    <el-button v-if="$route.name == 'idea_edit' && pass_after_audit == 0" type="primary" @click.stop="confirm">{{btnTxt}}</el-button>
                    <el-button v-if="$route.name == 'idea_edit' && pass_after_audit == 1" type="info" disabled>人工复审中</el-button>
                </template>
            </div>
            <div class="user-center">
                <div class="userInfo" @click.prevent.stop="goUserInfo()">
                    <img :src="$imgUrlFilter(userIcon || 'https://s.moimg.net/new/images/headPic.png', 68)" />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import domain from '@/service/domain'
import { mapState } from 'vuex'
export default {
    props: {
        stepIndex:{
            type: Number,
            default: 0,
        },
        pass_after_audit:{
            type: Number,
            default: 0,
        },
    },
  computed: {
    ...mapState({
      userId: state => state.user.user_id,
      userIcon: state => state.user.userIcon,
      ideaStatus: state => state.idea.status
    }),
    btnTxt(){
        return this.ideaStatus < 30 ? '提交审核' : '保存'
    },
    // eslint-disable-next-line vue/return-in-computed-property
    title(){
        if(this.$route.name == 'idea'){
            return '创意发布'
        }
        if(this.$route.name == 'idea_update'){
            return '更新创意'
        }
        if(this.$route.name == 'idea_edit'){
            return '编辑创意'
        }
    },
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    goUserInfo() {
      location.href = `${domain.me}/u/user_index`
    },
    confirm() {
        this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="scss">
header{
    width:100%;
    min-width:975px;
    height:70px;
    padding:20px 20px 20px 40px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1001;
    box-sizing: border-box;
    background: #fff;
    border-bottom: 1px solid #F2F3F3;
    display:flex;
    justify-content: space-between;
    align-items:center;
    font-size:16px;
    .left{
        display:flex;
        align-items:center;
        img{
            height:30px;
        }
        p{
            color:#222C37;
            padding-left:40px;
            cursor:pointer;
        }
    }
    .right{
        color:#7A8087;
        display:flex;
        align-items:center;
        .btn_list{
            display:flex;
            align-items:center;
            ::v-deep .el-button{
              min-width: 120px;
            }
        }
        .user-center{
            display:flex;
            align-items:center;
            i{
                margin-left: 24px;
                line-height: 30px;
                width: 17px;
                font-size: 18px;
                padding-left: 6px;
                color: #7a8087;
                cursor: pointer;
            }
            .userInfo{
                margin-left: 22px;
                position: relative;
                cursor: pointer;
                img{
                    display: block;
                    width: 30px;
                    height: 30px;
                    box-sizing: border-box;
                    overflow: hidden;
                    border-radius: 50%;
                    border: 1px solid #dee0e1;
                }
            }
        }
    }
  }
</style>
